import React from 'react';
import { Avatar, Box, Typography, useTheme } from '@mui/material';
import { useGateway } from 'hooks';
import { StyledBadge } from 'components/sidebar/components/avatar';

type GatewayItem = {
    title: string;
    website: string;
    collapse: boolean | undefined;
    onClick?: () => void;
    style?: any;
    status?: string | undefined;
};

const GatewayItem: React.FC<GatewayItem> = ({
    title,
    website,
    collapse,
    onClick,
    style,
    status,
}) => {
    const theme = useTheme();

    const handleOnClick = () => {
        onClick && onClick();
    };
    const active = useGateway();
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
                overflow: 'hidden',
                justifyContent: collapse ? 'flex-start' : 'center',
            }}
            onClick={handleOnClick}>
            <Avatar
                alt={title}
                sx={{
                    width: 30,
                    height: 30,
                    marginRight: collapse ? '15px' : '0',
                }}
                children={title.substring(0, 1)}
            />
            {collapse && (
                <Box
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {status && (
                            <StyledBadge
                                overlap="circular"
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                variant="dot"
                                sx={{
                                    mx: 1,
                                    '& .MuiBadge-badge': {
                                        color:
                                            status === 'activated'
                                                ? theme.palette.success.main
                                                : status === 'pending'
                                                  ? theme.palette.warning.main
                                                  : theme.palette.error.main,
                                        backgroundColor:
                                            status === 'activated'
                                                ? theme.palette.success.main
                                                : status === 'pending'
                                                  ? theme.palette.warning.main
                                                  : theme.palette.error.main,
                                    },
                                }}></StyledBadge>
                        )}

                        <Typography
                            noWrap
                            sx={{
                                fontSize: '15px',
                                ml: status ? 0.5 : 0,
                                color: 'text.secondary',
                                ...style,
                            }}>
                            {title}
                        </Typography>
                    </Box>

                    <Typography
                        noWrap
                        sx={{
                            fontSize: '10px',
                            pl: '2px',
                            color: 'text.secondary',
                            ...style,
                        }}>
                        {website}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default GatewayItem;
